<template>
  <div class="card-nighthawk-app" id="nighthawk_app" v-if="isShow">
    <div class="card-nighthawk-app-header">
      <img src="~images/app/nighthawk-logo.svg" alt="" />
      <p>{{ $t("app_basic_description2") }}</p>
      <span>
        <a :href="appDownloadLink" target="_blank">{{ $t("app_basic_description3") }}</a>
      </span>
    </div>

    <div class="device-content">
      <div class="disp-cell"><img src="~images/app/device-nighthawk.svg" alt="" /></div>
      <div class="disp-cell">
        <div class="app-icon-nighthawk">
          <img src="~images/app/nighthawk-app-icon.svg" class="" alt="" />
        </div>
        <a href="http://orbi-app.com" class="mb app-store" target="_blank"
          ><img src="~images/app/app-store-badge-us-black.svg" alt=""
        /></a>
        <a href="http://orbi-app.com" class="google-store" target="_blank"
          ><img src="~images/app/google-play-badge-us.svg" alt=""
        /></a>
      </div>
    </div>
    <div class="card-nighthawk-app-footer"><img src="~images/app/logo-netgear.svg" alt="" /></div>
  </div>
</template>
<script>
export default {
  computed: {
    appDownloadLink() {
      const desktop = "https://www.netgear.com/home/apps-services/orbi-app/";
      const app = "https://apps.apple.com/us/app/netgear-orbi/id1182184397";
      const store = "https://play.google.com/store/apps/details?id=com.dragonflow.android.orbi&hl=en";
      const device_type = this.getMobileOperatingSystem();

      if (this.$store.state.page.type != "orbi") {
        app = "https://itunes.apple.com/us/app/netgear-up/id1124666597";
        store = "https://play.google.com/store/apps/details?id=com.netgear.netgearup";
      }

      if (device_type == "Android") {
        return store;
      } else if (device_type == "iOS") {
        return app;
      }
      return desktop;
    },
    isShow() {
      return this.$route.path.includes("/basic");
    },
  },
  methods: {
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
        return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }

      return "unknown";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.card-nighthawk-app {
  border-radius: 5px;
  background-color: $appBgColor;
  width: 193px;
  color: #fff;
  font-family: "Avenir-Book";
  position: absolute;
  top: 275px;
  .card-nighthawk-app-header {
    text-align: center;
    padding: 15px 20px 0px 20px;
    font-size: 11px;
    margin-bottom: -22px;
    span a {
      color: #fff;
    }
  }
  p {
    max-width: 140px;
    margin: auto;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .device-content {
    position: relative;
    bottom: -23px;
  }
  .device-content > .disp-cell:first-child > img {
    display: block;
  }
  .disp-cell {
    padding-left: 15px;
    display: table-cell;
    vertical-align: top;
    text-align: center;
  }
  .app-icon-nighthawk {
    margin-top: 5px;
    display: inline-flex;
    margin-bottom: 10px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.85);
    border-radius: 10px;
    -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.85);
    max-height: 40px;
  }
  a {
    margin-bottom: 0px;
    display: block;
    transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
  }
  .mb {
    height: 24px;
    margin-bottom: 2px;
  }
  img {
    max-height: 100%;
    display: inline-block;
  }
  .card-nighthawk-app-footer {
    background: $appFooterColor;
    height: 23px;
    border-radius: 0px 0px 5px 5px;
    text-align: right;
    padding-right: 10px;
    img {
      float: right;
      margin-top: 8px;
    }
  }
}
</style>
